export class Environment {
    static baseUrl = 'https://app.compass.dev-relationshipone.com';
    static proxyServer = 'https://app.compass.dev-relationshipone.com';
}
